import { isPeopleRegex } from "hybridspace-telemetry";

export function isPlacesPeopleTab(pathname: string): boolean {
    const peopleRegex = new RegExp(isPeopleRegex, "i" /* Flag for case insensitive */);
    return (pathname.match(peopleRegex) || []).length > 0;
}
